"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const fmko_ts_common_1 = require("fmko-ts-common");
const HasValueWidget_1 = tslib_1.__importDefault(require("./HasValueWidget"));
class LabeledGroupWidget extends HasValueWidget_1.default {
    constructor(args) {
        super();
        const { groupChildElements } = args;
        this.groupChildElements = groupChildElements;
        this.decorateElement(args);
        this.element.classList.add("form-control");
    }
    getValue() {
        return this.value;
    }
    setValue(newValue, fireEvents = false) {
        const oldValue = this.value;
        this.value = newValue;
        if (fireEvents) {
            fmko_ts_common_1.ValueChangeEvent.fireIfNotEqual(this, oldValue, newValue);
        }
    }
    getGroupElement() {
        return this.groupElement;
    }
    getLabelElement() {
        return this.labelElement;
    }
    getLabel() {
        return this.labelElement.textContent || "";
    }
    setLabel(label) {
        this.labelElement.textContent = label;
    }
    getGroupChildElements() {
        return this.groupChildElements;
    }
    getHintText() {
        if (!this.hintElement) {
            throw new Error("Hint element was not initialized!");
        }
        return this.hintElement.textContent || "";
    }
    setHintText(hint) {
        if (!this.hintElement) {
            throw new Error("Hint element was not initialized!");
        }
        this.hintElement.textContent = hint;
    }
    isEnabled() {
        return this.groupElement.hasAttribute("disabled");
    }
    setEnabled(enabled) {
        this.element.classList.toggle("field-disabled", !enabled);
        this.groupElement.toggleAttribute("disabled", !enabled);
    }
    decorateElement(args) {
        const { label, labelHidden = false, labelImage, hint, testIdentifier } = args;
        const globalId = fmko_ts_common_1.GlobalCounter.next();
        this.groupElement = document.createElement("fieldset");
        this.element = this.groupElement;
        this.groupElement.id = globalId;
        if (testIdentifier) {
            this.groupElement.dataset.cy = testIdentifier;
        }
        this.labelElement = document.createElement("label");
        this.labelElement.htmlFor = this.groupElement.id;
        this.labelElement.hidden = labelHidden;
        this.setLabel(label);
        this.groupElement.setAttribute(fmko_ts_common_1.ARIA.LABEL, label);
        this.labelImage = labelImage;
        if (hint) {
            this.hintElement = document.createElement("small");
            this.hintElement.setAttribute("role", fmko_ts_common_1.ARIARole.COMMENT);
            this.hintElement.classList.add("group-hint-text");
            this.hintElement.textContent = hint;
        }
        this.decorateLabeledGroupElement(args);
    }
    ;
}
exports.default = LabeledGroupWidget;
//# sourceMappingURL=LabeledGroupWidget.js.map